import { Injectable } from '@angular/core';
import { PersonalizationsService } from '../base/services/personalizations/personalizations.service';
import { EnvironmentService } from '../api/api/environment.service';


@Injectable()
export class VersionService {

  versionAPI: string;
  urlEndpoint: string;


  constructor(private _env: EnvironmentService) {}

  getVersionAPI(): void {
    this.versionAPI = this._env.apiVersion;
  }

  getUrlEndpoint(url: string): string {
    this.getVersionAPI();
    this.urlEndpoint = url.replace('/api/', '/api/' + this.versionAPI + '/');
    return this.urlEndpoint;
  }

}
